/* lumen-anbefalt-styrestrom.js — totalpris + «Legg begge i kurven» for snippets/lumen-anbefalt-styrestrom.liquid.
   Egen knapp, egen forespørsel: hovedknappen, sticky-baren og «Kjøp nå» er urørt.
   Delegert på document, så boksen tåler at Dawn bytter ut deler av seksjonen ved variantbytte. */
(function () {
  if (window.lumenAnbefaltInit) return;
  window.lumenAnbefaltInit = true;

  function kr(cents) {
    return String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr';
  }

  function mainForm(box) {
    return document.getElementById(box.dataset.formId);
  }

  function mainQty(box) {
    var id = box.dataset.formId;
    var input = (id && document.querySelector('input[name="quantity"][form="' + id + '"]')) ||
      (mainForm(box) && mainForm(box).querySelector('input[name="quantity"]'));
    var q = input ? parseInt(input.value, 10) : 1;
    return q > 0 ? q : 1;
  }

  function checked(box) {
    return Array.prototype.slice.call(box.querySelectorAll('.lumen-anbefalt__check:checked'));
  }

  function update(box) {
    var total = parseInt(box.dataset.mainPrice, 10) * mainQty(box);
    var picked = checked(box);
    picked.forEach(function (c) { total += parseInt(c.dataset.price, 10); });
    var sum = box.querySelector('[data-anb-total]');
    if (sum) {
      sum.innerHTML = '<span class="lumen-p lumen-p--inkl">' + kr(total) + '</span>' +
        '<span class="lumen-p lumen-p--eks">' + kr(total / 1.25) + '</span>';
    }
    var label = box.querySelector('[data-anb-label]');
    var all = box.querySelectorAll('.lumen-anbefalt__check').length;
    if (label) {
      label.textContent = picked.length === 0 ? 'Legg i handlekurv'
        : picked.length === all ? (all > 1 ? 'Legg alle i kurven' : 'Legg begge i kurven')
        : 'Legg valgte i kurven';
    }
  }

  function updateAll() {
    document.querySelectorAll('[data-lumen-anbefalt]').forEach(update);
  }

  document.addEventListener('change', function (e) {
    var box = e.target.closest && e.target.closest('[data-lumen-anbefalt]');
    if (box) return update(box);
    if (e.target.name === 'quantity') updateAll();
  });
  document.addEventListener('input', function (e) {
    if (e.target.name === 'quantity') updateAll();
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('quantity-input button')) setTimeout(updateAll, 0);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
      var v = ev && ev.data && ev.data.variant;
      document.querySelectorAll('[data-lumen-anbefalt]').forEach(function (box) {
        if (v && typeof v.price === 'number') box.dataset.mainPrice = v.price;
        box.hidden = !!(v && v.available === false);
        update(box);
      });
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-anb-add]');
    if (!btn) return;
    var box = btn.closest('[data-lumen-anbefalt]');
    var form = mainForm(box);
    var idInput = form && form.querySelector('input[name="id"]');
    var err = box.querySelector('[data-anb-error]');
    if (!idInput || btn.getAttribute('aria-busy') === 'true') return;
    err.hidden = true;

    var items = [{ id: parseInt(idInput.value, 10), quantity: mainQty(box) }];
    checked(box).forEach(function (c) { items.push({ id: parseInt(c.value, 10), quantity: 1 }); });

    var cart = document.querySelector('mini-cart') || document.querySelector('cart-drawer');
    var body = { items: items };
    if (cart && cart.getSectionsToRender) {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      if (cart.setActiveElement) cart.setActiveElement(btn);
    }

    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('loading');
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          err.textContent = res.description || res.message || 'Noe gikk galt. Prøv igjen.';
          err.hidden = false;
          return;
        }
        if (cart && cart.renderContents && res.sections) cart.renderContents(res);
        else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lumen-anbefalt', cartData: res });
        }
      })
      .catch(function () {
        err.textContent = 'Noe gikk galt. Prøv igjen.';
        err.hidden = false;
      })
      .finally(function () {
        btn.removeAttribute('aria-busy');
        btn.classList.remove('loading');
      });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateAll);
  else updateAll();
})();
